import {env} from "../../environments/environment";
import {APP_ROUTES} from "./routes";
import {LandingPageDefinition} from "../interfaces/landing-page";

const LK_SCREEN = '/assets/start-page/lk-screen.png?2';
const BOT_IMAGE = '/assets/bot-page/ai.jpg';

const DASHBOARD_CURRENT_MILEAGE = '/assets/dashboard/current-mileage.png';
const DASHBOARD_EXPENSES_BY_YEARS = '/assets/dashboard/expenses-by-years.png';
const DASHBOARD_EXPENSES_SUMMARY = '/assets/dashboard/expenses-summary-by-period.png';
const DASHBOARD_FUEL_DYNAMICS = '/assets/dashboard/fuel-dynamics.png';
const DASHBOARD_FUEL_SUMMARY = '/assets/dashboard/fuel-summary.png';
const DASHBOARD_MILEAGE_BY_MONTHS = '/assets/dashboard/mileage-by-months.png';
const DASHBOARD_MILEAGE_BY_YEARS = '/assets/dashboard/mileage-by-years.png';
const DASHBOARD_MILEAGE_COMMON = '/assets/dashboard/mileage-common.png';
const DASHBOARD_TRIP_CALCULATOR = '/assets/dashboard/trip-calculator.png';

const FEATURE_PLAN_COMMON = '/assets/features/plan-to/common-view.png';
const FEATURE_PLAN_EXIST_EVENTS = '/assets/features/plan-to/exist-events.png';
const FEATURE_PLAN_FORM = '/assets/features/plan-to/form.png';
const FEATURE_PLAN_FUTURE = '/assets/features/plan-to/future-plan.png';
const FEATURE_PLAN_FILE_EXPORT = '/assets/features/plan-to/xlsx-export.png';
const FEATURE_MILEAGE_INDEX = '/assets/features/probeg/index.png';
const FEATURE_MILEAGE_FORM = '/assets/features/probeg/form.png';
const FEATURE_MONEY_INDEX = '/assets/features/rashody/index.png';
const FEATURE_MONEY_FORM = '/assets/features/rashody/form.png';
const FEATURE_SERVICE_INDEX = '/assets/features/service/index.png';
const FEATURE_SERVICE_FORM = '/assets/features/service/form.png';
const FEATURE_SERVICE_PROVIDER_INDEX = '/assets/features/service-providers/index-map.png';
const FEATURE_SERVICE_PROVIDER_FORM = '/assets/features/service-providers/form-map-logo.png';
const FEATURE_SERVICE_PROVIDER_DASHBOARD = '/assets/features/service-providers/dashboard-summary.png';
const FEATURE_FUEL_INDEX = '/assets/features/zapravka/index.png';
const FEATURE_FUEL_FORM = '/assets/features/zapravka/form.png';
const FEATURE_NOTES_HERO = '/assets/features/notes/notes-hero.png';
const FEATURE_NOTES_CHANNELS = '/assets/features/notes/notes-channels.png';

const EDITORIAL_HERO_CONTROL = '/assets/editorial/hero-control-editorial-v1.png';
const EDITORIAL_MAINTENANCE_PLAN = '/assets/editorial/maintenance-plan-editorial-v1.png';
const EDITORIAL_FUEL_MILEAGE = '/assets/editorial/fuel-mileage-editorial-v1.png';
const EDITORIAL_OWNERSHIP_ANALYTICS = '/assets/editorial/ownership-analytics-editorial-v1.png';

export const LANDING_PAGES: Record<string, LandingPageDefinition> = {
    home: {
        key: 'home',
        path: APP_ROUTES.INDEX,
        navLabel: 'Главная',
        applicationCategory: 'UtilitiesApplication',
        image: {
            src: LK_SCREEN,
            alt: 'MotorDesk для учёта автомобиля',
        },
        hero: {
            eyebrow: 'Личный кабинет автовладельца',
            lead: 'MotorDesk помогает держать автомобиль под контролем: сохранять историю обслуживания, планировать будущие работы, записывать пробег и заправки, фиксировать денежные расходы и видеть всю картину в одном месте.',
            chips: [
                'Учёт ТО',
                'Сервисные точки',
                'План ТО',
                'Заправки',
                'Пробег',
                'Денежные расходы',
                'Заметки',
                'Telegram-бот',
            ],
            bullets: [
                'Подходит для одной или нескольких машин.',
                'Полезен и для повседневных записей, и для планирования будущих работ.',
                'Помогает видеть не отдельные события, а общую стоимость и ритм владения автомобилем.',
            ],
            primaryAction: {
                label: 'Создать кабинет',
                url: env.URL_LK_REGISTER,
                external: true,
            },
            secondaryAction: {
                label: 'Посмотреть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
            image: {
                src: LK_SCREEN,
                alt: 'Главный экран MotorDesk',
                caption: 'Когда данные по машине собраны вместе, проще и помнить важные события, и заранее готовиться к расходам.',
            },
        },
        intro: {
            title: 'Сервис для тех, кто хочет спокойнее владеть автомобилем',
            text: 'Если расходы по машине утекают незаметно, обслуживание вспоминается в последний момент, а история событий теряется между заметками и чатами, MotorDesk помогает собрать всё в одну понятную систему.',
        },
        sections: [
            {
                id: 'feature-cluster',
                eyebrow: 'Что можно вести',
                title: 'У каждого важного вопроса по машине есть свой понятный раздел',
                lead: 'Вы можете начать с того, что беспокоит вас сильнее всего прямо сейчас: обслуживание, план будущих работ, заправки, пробег или денежные траты.',
                paragraphs: [
                    'Так проще не перегружать себя сразу всем и быстрее увидеть практическую пользу именно в своём сценарии.',
                ],
                cards: [
                    {
                        title: 'Учёт ТО',
                        text: 'Сохраняйте выполненные работы, сервисные точки, стоимость и важные детали по обслуживанию.',
                        action: {
                            label: 'Перейти к учёту ТО',
                            url: APP_ROUTES.MAINTENANCE.INDEX,
                        },
                    },
                    {
                        title: 'План ТО',
                        text: 'Задавайте будущие работы по дате или пробегу и заранее понимайте, когда они станут актуальны.',
                        action: {
                            label: 'Перейти к плану ТО',
                            url: APP_ROUTES.PLAN.INDEX,
                        },
                    },
                    {
                        title: 'Сервисные точки',
                        text: 'Держите под рукой СТО и мастеров: адреса, телефоны, карту, график работы и связь с расходами.',
                        action: {
                            label: 'Перейти к сервисам',
                            url: APP_ROUTES.SERVICE_PROVIDERS.INDEX,
                        },
                    },
                    {
                        title: 'Заправки и пробег',
                        text: 'Фиксируйте регулярные события, которые потом помогают точнее видеть всю картину по машине.',
                        action: {
                            label: 'Открыть возможности',
                            url: APP_ROUTES.FEATURES.INDEX,
                        },
                    },
                ],
            },
            {
                id: 'daily-control',
                eyebrow: 'Почему это удобно',
                title: 'Когда обслуживание, топливо и расходы видны вместе, решения принимать проще',
                paragraphs: [
                    'Пробег помогает понимать темп эксплуатации, заправки показывают топливную картину, сервисная история не даёт потерять важные работы, а денежные расходы показывают, во сколько действительно обходится машина.',
                    'В итоге вы лучше понимаете, какие траты приближаются, когда стоит ехать в сервис и где автомобиль начал обходиться дороже обычного.',
                ],
                image: {
                    src: EDITORIAL_OWNERSHIP_ANALYTICS,
                    alt: 'Владелец автомобиля изучает аналитику и расходы по машине',
                    caption: 'Когда расходы, топливо и обслуживание видны вместе, картину по машине проще оценивать спокойно и заранее.',
                },
                actions: [
                    {
                        label: 'Учёт пробега',
                        url: APP_ROUTES.MILEAGE.INDEX,
                    },
                    {
                        label: 'Заправки автомобиля',
                        url: APP_ROUTES.FUEL.INDEX,
                    },
                    {
                        label: 'Денежные расходы',
                        url: APP_ROUTES.MONEY.INDEX,
                    },
                    {
                        label: 'Сервисные точки',
                        url: APP_ROUTES.SERVICE_PROVIDERS.INDEX,
                    },
                ],
            },
            {
                id: 'demo-and-registration',
                eyebrow: 'С чего начать',
                title: 'Сначала можно спокойно посмотреть демо, а затем уже перенести машину в кабинет',
                paragraphs: [
                    'Демо-режим показывает, как выглядит кабинет с реальными по смыслу данными. Это помогает быстро понять, подходит ли вам такой формат учёта.',
                    'Если сервис вам откликается, дальше можно открыть личный кабинет и начать вести автомобиль уже под себя.',
                ],
                steps: [
                    'Откройте демо и посмотрите, как устроены записи по машине.',
                    'Выберите раздел, который ближе вашей текущей задаче.',
                    'Перейдите в кабинет и начните вести автомобиль в одном месте.',
                ],
                actions: [
                    {
                        label: 'Открыть демо',
                        url: env.URL_LK_DEMO,
                        external: true,
                    },
                    {
                        label: 'Создать кабинет',
                        url: env.URL_LK_REGISTER,
                        external: true,
                    },
                ],
            },
        ],
        faq: [
            {
                question: 'Для чего нужен MotorDesk?',
                answer: 'MotorDesk нужен, чтобы вести историю автомобиля в одном месте: обслуживание, план будущих работ, пробег, заправки и денежные расходы.',
            },
            {
                question: 'Как посмотреть MotorDesk перед началом работы?',
                answer: 'Да. Для этого есть demo-режим с насыщенными обезличенными данными и read-only доступом к кабинету.',
            },
            {
                question: 'Подходит ли MotorDesk для планирования обслуживания?',
                answer: 'Да. В сервисе можно не только хранить уже выполненные работы, но и заранее планировать будущие события по дате и пробегу.',
            },
            {
                question: 'Можно ли вести несколько автомобилей?',
                answer: 'Да. MotorDesk подходит и для одной машины, и для ситуации, когда нужно держать под контролем несколько автомобилей.',
            },
        ],
        cta: {
            title: 'Создайте кабинет для своей машины и начните с одной полезной записи',
            text: 'Добавьте автомобиль и начните с пробега, заправки или ближайшей работы. Если сначала хотите познакомиться с интерфейсом, откройте демо.',
            primaryAction: {
                label: 'Создать кабинет',
                url: env.URL_LK_REGISTER,
                external: true,
            },
            secondaryAction: {
                label: 'Посмотреть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
        },
        howTo: {
            name: 'Как начать пользоваться MotorDesk',
            steps: [
                'Откройте demo-режим и посмотрите, как выглядят данные по автомобилю.',
                'Выберите раздел, который ближе вашей задаче: обслуживание, план, заправки, пробег или расходы.',
                'Перейдите в кабинет и начните вести автомобиль системно.',
            ],
        },
    },
    tools: {
        key: 'tools',
        path: APP_ROUTES.TOOLS.INDEX,
        navLabel: 'Инструменты',
        applicationCategory: 'UtilitiesApplication',
        image: {
            src: DASHBOARD_TRIP_CALCULATOR,
            alt: 'Инструменты MotorDesk для расчётов по автомобилю',
        },
        hero: {
            eyebrow: 'Инструменты для автовладельца',
            lead: 'Выберите нужный расчёт: узнайте расстояние между городами, оцените расход топлива и стоимость поездки или перейдите к учёту автомобиля.',
            chips: [
                'Расстояние между городами',
                'Калькулятор поездки',
                'Расход топлива',
                'Стоимость маршрута',
                'Расчёт в Telegram',
            ],
            bullets: [
                'Постройте маршрут между городами или введите известный километраж вручную.',
                'Рассчитайте топливо, цену километра и общую стоимость поездки.',
                'Сохраните данные автомобиля в кабинете, чтобы точнее учитывать его эксплуатацию.',
            ],
            primaryAction: {
                label: 'Калькулятор поездки',
                url: APP_ROUTES.TRIP_CALCULATOR.INDEX,
            },
            secondaryAction: {
                label: 'Открыть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
            image: {
                src: DASHBOARD_TRIP_CALCULATOR,
                alt: 'Каталог инструментов MotorDesk для автовладельца',
                caption: 'Все основные расчёты для поездки собраны в одном разделе.',
            },
        },
        intro: {
            title: 'Начните с задачи, которую нужно решить сейчас',
            text: 'Рассчитайте маршрут и расходы на поездку, воспользуйтесь Telegram-ботом или перейдите к учёту пробега, заправок и обслуживания.',
        },
        sections: [
            {
                id: 'available-tools',
                eyebrow: 'Доступные инструменты',
                title: 'Выберите инструмент под текущую задачу',
                lead: 'Узнайте расстояние между городами, рассчитайте стоимость поездки или откройте связанный раздел MotorDesk.',
                paragraphs: [
                    'Полученный километраж можно сразу использовать для расчёта топлива и итоговой стоимости маршрута.',
                ],
                cards: [
                    {
                        title: 'Расстояние между городами',
                        text: 'Выберите города и получите километраж по дорогам, примерное время в пути и маршрут туда-обратно.',
                        action: {
                            label: 'Рассчитать расстояние',
                            url: APP_ROUTES.ROUTE_DISTANCE.INDEX,
                        },
                    },
                    {
                        title: 'Калькулятор поездки',
                        text: 'Рассчитайте примерную стоимость маршрута, расход топлива, цену километра и поездку туда-обратно.',
                        action: {
                            label: 'Открыть калькулятор',
                            url: APP_ROUTES.TRIP_CALCULATOR.INDEX,
                        },
                    },
                    {
                        title: 'Расчёт поездки в Telegram',
                        text: 'Отправьте боту дистанцию и укажите, учитывать ли обратную дорогу.',
                        action: {
                            label: 'Telegram-бот',
                            url: APP_ROUTES.BOT.INDEX,
                        },
                    },
                    {
                        title: 'Заправки и расход топлива',
                        text: 'Раздел для регулярного учёта топлива, который делает будущие расчёты точнее.',
                        action: {
                            label: 'Заправки автомобиля',
                            url: APP_ROUTES.FUEL.INDEX,
                        },
                    },
                ],
            },
            {
                id: 'telegram-trip-calculation',
                eyebrow: 'В дороге',
                title: 'Расчёт поездки можно использовать и через Telegram-бота',
                paragraphs: [
                    'Выберите в боте пункт «Рассчитать поездку», отправьте расстояние и ответьте, учитывать ли обратную дорогу. Бот вернёт примерную стоимость, литры топлива и цену километра.',
                    'Такой формат удобен, когда вы планируете маршрут с телефона и не хотите открывать браузер ради быстрого расчёта.',
                ],
                actions: [
                    {
                        label: 'Telegram-бот MotorDesk',
                        url: APP_ROUTES.BOT.INDEX,
                    },
                    {
                        label: 'Открыть бота',
                        url: env.BOT_URL,
                        external: true,
                    },
                ],
            },
            {
                id: 'next-tools',
                eyebrow: 'Больше возможностей',
                title: 'Дополните расчёты данными своего автомобиля',
                paragraphs: [
                    'История пробега, заправок и обслуживания помогает точнее оценивать стоимость эксплуатации и заранее планировать будущие работы.',
                ],
                cards: [
                    {
                        title: 'Стоимость 1 км',
                        text: 'Рассчитайте цену километра с учётом топлива, обслуживания и других расходов.',
                        action: {
                            label: 'Читать статью',
                            url: APP_ROUTES.BLOG.INDEX + '/stoimost-1-km-probega-avtomobilya',
                        },
                    },
                    {
                        title: 'Стоимость владения',
                        text: 'Соберите обслуживание и регулярные расходы в кабинете, чтобы видеть общую картину по машине.',
                        action: {
                            label: 'Денежные расходы',
                            url: APP_ROUTES.MONEY.INDEX,
                        },
                    },
                    {
                        title: 'Планирование ТО',
                        text: 'Расчёты по пробегу хорошо дополняют план будущих работ и помогают заранее видеть ближайшие траты.',
                        action: {
                            label: 'План ТО',
                            url: APP_ROUTES.PLAN.INDEX,
                        },
                    },
                ],
            },
        ],
        faq: [
            {
                question: 'Что можно посчитать в инструментах MotorDesk?',
                answer: 'Можно рассчитать расстояние и время между городами по дорогам, фактический расход топлива, примерный расход и стоимость поездки.',
            },
            {
                question: 'Как сделать расчёт поездки точнее?',
                answer: 'Уточните цену топлива и средний расход своего автомобиля. В личном кабинете расчёт также может опираться на историю заправок и расходов.',
            },
            {
                question: 'Можно ли рассчитать поездку в Telegram?',
                answer: 'Да. В Telegram-боте MotorDesk можно выбрать пункт «Рассчитать поездку», отправить расстояние и указать, учитывать ли обратную дорогу.',
            },
        ],
        cta: {
            title: 'Выберите быстрый инструмент или переходите к точному учёту автомобиля',
            text: 'Начните с конкретного расчёта, а в личном кабинете ведите заправки, обслуживание, пробег и другие расходы по своей машине.',
            primaryAction: {
                label: 'Расстояние между городами',
                url: APP_ROUTES.ROUTE_DISTANCE.INDEX,
            },
            secondaryAction: {
                label: 'Открыть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
        },
        howTo: {
            name: 'Как выбрать инструмент в MotorDesk',
            steps: [
                'Откройте раздел «Инструменты».',
                'Выберите нужную карточку: расстояние между городами, калькулятор поездки, Telegram-бот или раздел учёта.',
                'Перейдите на отдельную страницу инструмента или возможности.',
                'Используйте быстрый расчёт, а для точных данных ведите историю автомобиля в личном кабинете.',
            ],
        },
    },
    features: {
        key: 'features',
        path: APP_ROUTES.FEATURES.INDEX,
        navLabel: 'Возможности',
        applicationCategory: 'UtilitiesApplication',
        image: {
            src: DASHBOARD_EXPENSES_SUMMARY,
            alt: 'Возможности MotorDesk для автовладельца',
        },
        hero: {
            eyebrow: 'Возможности MotorDesk',
            lead: 'Здесь собраны ключевые задачи, которые чаще всего волнуют автовладельца: история обслуживания, план будущих работ, заправки, пробег, денежные расходы и быстрый доступ через Telegram-бот.',
            chips: [
                'История обслуживания',
                'Сервисные точки',
                'План будущих работ',
                'Заправки',
                'Калькулятор поездки',
                'Пробег',
                'Денежные расходы',
                'Заметки',
                'Telegram-бот',
            ],
            bullets: [
                'Можно быстро перейти именно к той теме, которая важна вам сейчас.',
                'Каждый раздел показывает, какую задачу он закрывает на практике.',
                'После знакомства с нужной функцией проще решить, подходит ли сервис именно вам.',
            ],
            primaryAction: {
                label: 'Открыть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
            secondaryAction: {
                label: 'Открыть кабинет',
                url: env.URL_LK,
                external: true,
            },
            image: {
                src: DASHBOARD_EXPENSES_SUMMARY,
                alt: 'Сводка по расходам и событиям автомобиля в MotorDesk',
                caption: 'MotorDesk помогает видеть автомобиль не по отдельным заметкам, а как цельную историю владения.',
            },
        },
        intro: {
            title: 'Выберите ту задачу, которую хотите закрыть первой',
            text: 'Кому-то важно не терять историю обслуживания. Кому-то — заранее понимать будущие траты на сервис. А кто-то хочет начать с заправок, пробега или мелких расходов. В MotorDesk можно двигаться от самого важного для вас.',
        },
        sections: [
            {
                id: 'service-cluster',
                eyebrow: 'Обслуживание',
                title: 'Если важно помнить, что уже сделано и что предстоит по машине',
                paragraphs: [
                    'В обслуживании обычно есть две разные задачи: хранить историю уже выполненных работ и заранее понимать, когда приближаются новые. В MotorDesk для этого есть отдельные разделы, чтобы не смешивать прошлое и будущее.',
                ],
                image: {
                    src: EDITORIAL_MAINTENANCE_PLAN,
                    alt: 'Планирование обслуживания автомобиля и будущих работ',
                    caption: 'Когда будущие работы и сервисные ориентиры видны заранее, обслуживание проще держать под контролем.',
                },
                cards: [
                    {
                        title: 'Учёт ТО автомобиля',
                        text: 'Сохраняйте выполненные работы, сервисные точки, комментарии и стоимость обслуживания.',
                        action: {
                            label: 'Открыть раздел',
                            url: APP_ROUTES.MAINTENANCE.INDEX,
                        },
                    },
                    {
                        title: 'План ТО автомобиля',
                        text: 'Заранее задавайте будущие работы по дате или пробегу и планируйте бюджет без авралов.',
                        action: {
                            label: 'Открыть раздел',
                            url: APP_ROUTES.PLAN.INDEX,
                        },
                    },
                    {
                        title: 'Сервисные точки',
                        text: 'Храните адреса, телефоны, карту и статистику по сервисам, где обслуживался автомобиль.',
                        action: {
                            label: 'Открыть раздел',
                            url: APP_ROUTES.SERVICE_PROVIDERS.INDEX,
                        },
                    },
                ],
            },
            {
                id: 'daily-cluster',
                eyebrow: 'Повседневные записи',
                title: 'Если хотите проще фиксировать то, что происходит с машиной регулярно',
                paragraphs: [
                    'Заправки и пробег удобнее вести тогда, когда путь до записи короткий. Чем проще сохранять такие события, тем полнее потом становится вся картина по автомобилю.',
                ],
                image: {
                    src: EDITORIAL_FUEL_MILEAGE,
                    alt: 'Водитель сохраняет заправку и пробег рядом с автомобилем',
                    caption: 'Короткий путь до записи помогает не откладывать заправки и пробег на потом.',
                },
                cards: [
                    {
                        title: 'Заправки автомобиля',
                        text: 'Литры, стоимость, цена за литр и связь с пробегом в одной истории.',
                        action: {
                            label: 'Открыть раздел',
                            url: APP_ROUTES.FUEL.INDEX,
                        },
                    },
                    {
                        title: 'Калькулятор расхода на поездку',
                        text: 'Показывает стоимость поездки по топливу, обслуживанию и прочим расходам на основе вашей истории.',
                        action: {
                            label: 'Открыть раздел',
                            url: APP_ROUTES.TRIP_CALCULATOR.INDEX,
                        },
                    },
                    {
                        title: 'Учёт пробега автомобиля',
                        text: 'Сохраняйте историю километража и используйте её как основу для других важных расчётов.',
                        action: {
                            label: 'Открыть раздел',
                            url: APP_ROUTES.MILEAGE.INDEX,
                        },
                    },
                    {
                        title: 'Telegram-бот',
                        text: 'Записывайте часть событий и открывайте нужные данные без браузера.',
                        action: {
                            label: 'Открыть раздел',
                            url: APP_ROUTES.BOT.INDEX,
                        },
                    },
                    {
                        title: 'Заметки автовладельца',
                        text: 'Сохраняйте симптомы, номера деталей, вопросы мастеру и любые короткие мысли, которые важно не забыть.',
                        action: {
                            label: 'Открыть раздел',
                            url: APP_ROUTES.NOTES.INDEX,
                        },
                    },
                ],
            },
            {
                id: 'money-cluster',
                eyebrow: 'Расходы',
                title: 'Если важно видеть не только топливо и сервис, но и все остальные траты по машине',
                paragraphs: [
                    'Парковка, мойка, налоги, штрафы, страховка и прочие платежи тоже влияют на стоимость владения автомобилем. Когда такие расходы записываются отдельно и аккуратно, они перестают растворяться в памяти.',
                    'Это помогает лучше понимать общую нагрузку на бюджет и замечать повторяющиеся расходы.',
                ],
                image: {
                    src: EDITORIAL_OWNERSHIP_ANALYTICS,
                    alt: 'Аналитика стоимости владения автомобилем и повседневных расходов',
                    caption: 'Даже небольшие траты заметнее, когда они собираются в общую финансовую картину по машине.',
                },
                actions: [
                    {
                        label: 'Денежные расходы на авто',
                        url: APP_ROUTES.MONEY.INDEX,
                    },
                    {
                        label: 'Заправки автомобиля',
                        url: APP_ROUTES.FUEL.INDEX,
                    },
                    {
                        label: 'Калькулятор поездки',
                        url: APP_ROUTES.TRIP_CALCULATOR.INDEX,
                    },
                ],
            },
        ],
        faq: [
            {
                question: 'Что можно делать в MotorDesk?',
                answer: 'В MotorDesk можно вести историю обслуживания, планировать будущие работы, записывать пробег и заправки, фиксировать денежные расходы и использовать Telegram-бот для быстрых действий.',
            },
            {
                question: 'С чего лучше начать знакомство с сервисом?',
                answer: 'Обычно удобнее начать с той задачи, которая беспокоит сильнее всего прямо сейчас: обслуживание, планирование, топливо, пробег или расходы.',
            },
            {
                question: 'Можно ли посмотреть сервис перед регистрацией?',
                answer: 'Да. Для этого есть demo-режим, где можно спокойно посмотреть, как устроены данные по автомобилю.',
            },
        ],
        cta: {
            title: 'Выберите раздел, который поможет вам уже сегодня',
            text: 'Так проще понять, как именно MotorDesk пригодится в вашем случае, а потом уже перейти в демо или сразу открыть кабинет.',
            primaryAction: {
                label: 'Открыть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
            secondaryAction: {
                label: 'Учёт ТО автомобиля',
                url: APP_ROUTES.MAINTENANCE.INDEX,
            },
        },
    },
    maintenance: {
        key: 'maintenance',
        path: APP_ROUTES.MAINTENANCE.INDEX,
        navLabel: 'Учёт ТО',
        applicationCategory: 'UtilitiesApplication',
        image: {
            src: FEATURE_SERVICE_INDEX,
            alt: 'Учёт технического обслуживания автомобиля в MotorDesk',
        },
        hero: {
            eyebrow: 'Учёт технического обслуживания автомобиля',
            lead: 'MotorDesk помогает сохранять уже выполненные работы по машине: дату, пробег, стоимость, сервисную точку, расходники и важные комментарии. Так история обслуживания остаётся под рукой и не теряется со временем.',
            chips: [
                'История обслуживания',
                'Выполненные работы',
                'Сервисные точки',
                'Стоимость обслуживания',
            ],
            bullets: [
                'Помогает помнить, что уже делалось по машине и когда.',
                'Удобен для повседневного владения и подготовки прозрачной истории автомобиля.',
                'Хорошо читается рядом с пробегом и общими расходами на машину.',
            ],
            primaryAction: {
                label: 'Открыть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
            secondaryAction: {
                label: 'План ТО автомобиля',
                url: APP_ROUTES.PLAN.INDEX,
            },
            image: {
                src: FEATURE_SERVICE_INDEX,
                alt: 'История обслуживания автомобиля в MotorDesk',
                caption: 'Когда история обслуживания хранится в одном месте, проще быстро восстановить контекст по машине.',
            },
        },
        intro: {
            title: 'Учёт ТО нужен, чтобы обслуживание перестало держаться только на памяти',
            text: 'Через несколько месяцев после визита в сервис бывает трудно вспомнить, что именно делалось, на каком пробеге это было и сколько стоило. MotorDesk помогает сохранять эти детали так, чтобы к ним было удобно возвращаться.',
        },
        sections: [
            {
                id: 'maintenance-history',
                eyebrow: 'Что сохраняется',
                title: 'Каждое обслуживание остаётся в общей истории автомобиля',
                paragraphs: [
                    'Вы видите не только факт визита в сервис, но и весь полезный контекст вокруг него: дату, пробег, состав работ, расходники и заметки по событию.',
                    'Это особенно удобно, когда машиной пользуются несколько человек или когда по одной машине накопилось уже много событий.',
                ],
                image: {
                    src: FEATURE_SERVICE_FORM,
                    alt: 'Форма добавления обслуживания в MotorDesk',
                    caption: 'Чем подробнее сохранены детали обслуживания, тем проще потом ориентироваться в истории по машине.',
                },
                cards: [
                    {
                        title: 'Дата и пробег',
                        text: 'Помогают понимать, в каком состоянии автомобиля проводилась работа.',
                    },
                    {
                        title: 'Состав работ',
                        text: 'Замены масла, фильтров, ремней, шиномонтаж и любые другие операции остаются в истории.',
                    },
                    {
                        title: 'Комментарии',
                        text: 'Можно быстро вспомнить нюансы без поиска по чекам и перепискам.',
                    },
                ],
            },
            {
                id: 'service-points',
                eyebrow: 'Где обслуживалась машина',
                title: 'Сервисные точки помогают помнить, к кому и куда вы обращались',
                paragraphs: [
                    'Если к событию привязан сервис или мастер, история становится ещё полезнее. Проще возвращаться в проверенные места, сравнивать прошлый опыт и не терять исполнителей, которым вы доверяете.',
                ],
                bullets: [
                    'Привязка работ к сервису или мастеру.',
                    'Понятная история по каждому визиту.',
                    'Удобство повторного обращения в те же точки.',
                ],
                actions: [
                    {
                        label: 'Сервисные точки',
                        url: APP_ROUTES.SERVICE_PROVIDERS.INDEX,
                    },
                ],
            },
            {
                id: 'maintenance-money',
                eyebrow: 'Связь с другими разделами',
                title: 'История обслуживания особенно полезна рядом с расходами, пробегом и планом будущих работ',
                paragraphs: [
                    'Когда обслуживание читается рядом с пробегом и расходами, проще понимать, сколько реально стоит содержание автомобиля и какие работы начинают повторяться чаще обычного.',
                    'А если вам важно не только хранить прошлые события, но и заранее понимать будущие, рядом есть отдельный раздел плана ТО.',
                ],
                image: {
                    src: DASHBOARD_EXPENSES_BY_YEARS,
                    alt: 'Расходы на обслуживание автомобиля по годам в MotorDesk',
                    caption: 'Связка истории обслуживания с расходами помогает лучше понимать стоимость владения автомобилем.',
                },
                actions: [
                    {
                        label: 'План ТО автомобиля',
                        url: APP_ROUTES.PLAN.INDEX,
                    },
                    {
                        label: 'Денежные расходы на авто',
                        url: APP_ROUTES.MONEY.INDEX,
                    },
                ],
            },
        ],
        faq: [
            {
                question: 'Как вести учёт ТО автомобиля?',
                answer: 'Удобнее всего сохранять выполненные работы в одном месте с датой, пробегом, составом обслуживания, сервисной точкой и стоимостью. Именно так это устроено в MotorDesk.',
            },
            {
                question: 'Можно ли хранить историю обслуживания автомобиля?',
                answer: 'Да. MotorDesk сохраняет выполненные обслуживания как часть общей истории машины, чтобы они не терялись и были доступны в нужный момент.',
            },
            {
                question: 'Зачем нужны сервисные точки?',
                answer: 'Они помогают помнить, где именно обслуживалась машина, и быстрее возвращаться к проверенным сервисам или мастерам.',
            },
            {
                question: 'Где в MotorDesk находится планирование будущего ТО?',
                answer: 'Для этого есть отдельный раздел плана ТО, где можно заранее задать будущую работу по дате или пробегу.',
            },
        ],
        cta: {
            title: 'Соберите историю обслуживания так, чтобы к ней было удобно возвращаться',
            text: 'Если хотите заранее понимать и будущие сервисные события, переходите к разделу плана ТО рядом с историей уже выполненных работ.',
            primaryAction: {
                label: 'Открыть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
            secondaryAction: {
                label: 'План ТО автомобиля',
                url: APP_ROUTES.PLAN.INDEX,
            },
        },
    },
    serviceProviders: {
        key: 'serviceProviders',
        path: APP_ROUTES.SERVICE_PROVIDERS.INDEX,
        navLabel: 'Сервисные точки',
        applicationCategory: 'UtilitiesApplication',
        image: {
            src: FEATURE_SERVICE_PROVIDER_INDEX,
            alt: 'Сервисные точки автомобиля в MotorDesk',
        },
        hero: {
            eyebrow: 'Сервисные точки автомобиля',
            lead: 'MotorDesk помогает вести собственный справочник СТО, мастерских и мастеров: контакты, адреса, сайт, логотип, график работы, отметку на карте и аналитику расходов по каждой сервисной точке.',
            chips: [
                'СТО и мастера',
                'Телефоны',
                'Адреса и карта',
                'График работы',
                'Логотип сервиса',
                'История визитов',
                'Расходы по точкам',
            ],
            bullets: [
                'Проще не терять контакты сервисов, к которым уже обращались и которым доверяете.',
                'Карта и поиск адреса помогают быстро сохранить расположение точки без ручного ввода координат.',
                'Аналитика показывает, где чаще обслуживался автомобиль и какие сервисы забирают большую часть бюджета.',
            ],
            primaryAction: {
                label: 'Открыть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
            secondaryAction: {
                label: 'Учёт ТО автомобиля',
                url: APP_ROUTES.MAINTENANCE.INDEX,
            },
            image: {
                src: FEATURE_SERVICE_PROVIDER_INDEX,
                alt: 'Список сервисных точек с картой и фильтрами в MotorDesk',
                caption: 'Список сервисных точек становится полезнее, когда рядом есть карта, фильтры, телефоны и связь с выполненными ТО.',
            },
        },
        intro: {
            title: 'Сервисные точки нужны, чтобы опыт обслуживания не растворялся в чеках, заметках и переписках',
            text: 'После нескольких визитов к разным мастерам легко забыть, где делали конкретную работу, кому можно снова позвонить, как туда ехать и какой сервис оказался удобнее. MotorDesk связывает места обслуживания с историей ТО, чтобы нужные контакты и прошлый опыт всегда были под рукой.',
        },
        sections: [
            {
                id: 'service-provider-card',
                eyebrow: 'Карточка сервиса',
                title: 'Карточка сервисной точки хранит контакты, адрес и контекст для будущих визитов',
                paragraphs: [
                    'Для сервисной точки можно сохранить название, сайт, логотип, адрес, телефоны, заметки и режим работы. Адрес связан с картой: координаты можно определить по введённому адресу или уточнить перемещением метки.',
                    'Так карточка становится не просто строкой в справочнике, а рабочим местом, куда удобно вернуться перед следующей записью на обслуживание.',
                ],
                cards: [
                    {
                        title: 'Контакты',
                        text: 'Телефоны можно вести списком: сначала сам номер, затем при необходимости подпись вроде приёмки, записи или мастера.',
                    },
                    {
                        title: 'Расположение',
                        text: 'Адрес, поиск координат и метка на карте помогают быстро понять, где находится сервисная точка.',
                    },
                    {
                        title: 'Визуальная узнаваемость',
                        text: 'Логотип можно взять с сайта, указать URL или загрузить собственный файл, чтобы сервис проще узнавался в списке.',
                    },
                    {
                        title: 'Режим работы',
                        text: 'График по дням недели помогает не искать каждый раз, когда сервис открыт и когда удобнее планировать визит.',
                    },
                ],
                image: {
                    src: FEATURE_SERVICE_PROVIDER_FORM,
                    alt: 'Карточка сервисной точки с логотипом, адресом и картой в MotorDesk',
                    caption: 'В карточке сервиса собраны данные, которые обычно приходится искать в разных местах: сайт, логотип, адрес, телефоны и карта.',
                },
            },
            {
                id: 'service-provider-map',
                eyebrow: 'Карта',
                title: 'Карта помогает выбирать сервис не только по названию, но и по расположению',
                paragraphs: [
                    'На индексной странице сервисные точки отображаются на карте, а рядом находится фильтр по ключевым признакам. Можно быстро сузить список по названию, статусу, наличию сайта, телефона, логотипа или отметки на карте.',
                    'Это особенно удобно, когда у вас есть несколько привычных мест обслуживания: одно рядом с домом, другое рядом с работой, третье подходит только для сезонных работ.',
                ],
                bullets: [
                    'Список и карта показывают одну и ту же подборку сервисных точек.',
                    'Если координаты есть, точка видна на карте понятной меткой.',
                    'Фильтры помогают быстро найти нужный сервис даже в большом справочнике.',
                ],
                image: {
                    src: FEATURE_SERVICE_PROVIDER_INDEX,
                    alt: 'Карта и фильтр сервисных точек автомобиля в MotorDesk',
                    caption: 'Карта особенно полезна, когда сервисов становится больше одного-двух и важно видеть их географию.',
                },
            },
            {
                id: 'service-provider-table',
                eyebrow: 'Список',
                title: 'Таблица показывает важные признаки точки без перехода в карточку',
                paragraphs: [
                    'В списке сервисных точек видны логотип, сайт, телефон, адрес, наличие метки на карте, статус и режим работы. При этом координаты не занимают место в таблице: если отметка есть, достаточно понятной инфографики.',
                    'Так индексная страница остаётся справочником, а не сухой таблицей с техническими полями.',
                ],
                cards: [
                    {
                        title: 'Быстро найти контакт',
                        text: 'Телефон и сайт видны прямо в списке, поэтому не нужно каждый раз открывать карточку.',
                    },
                    {
                        title: 'Понять доступность',
                        text: 'Статус и график работы помогают оценить, актуальна ли точка для следующего визита.',
                    },
                    {
                        title: 'Не перегружать адрес',
                        text: 'Адрес выводится компактно, а наличие координат отмечается отдельным значком карты.',
                    },
                ],
            },
            {
                id: 'service-provider-analytics',
                eyebrow: 'Аналитика',
                title: 'Расходы по сервисным точкам помогают понять, где реально обслуживается автомобиль',
                paragraphs: [
                    'На главной странице личного кабинета можно смотреть структуру расходов по сервисным точкам за выбранный период. Это дополняет обычную историю ТО: видно не только что делали с машиной, но и где сосредоточены затраты.',
                    'Такая аналитика помогает сравнивать сервисы между собой, замечать самые затратные точки и спокойнее принимать решение, куда возвращаться в следующий раз.',
                ],
                image: {
                    src: FEATURE_SERVICE_PROVIDER_DASHBOARD,
                    alt: 'Аналитика расходов по сервисным точкам на главной странице MotorDesk',
                    caption: 'Диаграмма показывает, какие сервисные точки чаще всего участвуют в расходах на обслуживание.',
                },
                actions: [
                    {
                        label: 'Учёт ТО автомобиля',
                        url: APP_ROUTES.MAINTENANCE.INDEX,
                    },
                    {
                        label: 'План ТО автомобиля',
                        url: APP_ROUTES.PLAN.INDEX,
                    },
                ],
            },
        ],
        faq: [
            {
                question: 'Что такое сервисная точка в MotorDesk?',
                answer: 'Это карточка СТО, мастерской или мастера, которую можно привязывать к событиям обслуживания автомобиля.',
            },
            {
                question: 'Можно ли добавить несколько телефонов сервиса?',
                answer: 'Да. В карточке сервисной точки можно хранить один или несколько телефонов. Для каждого номера можно добавить необязательное название, например приёмка, запись или мастер.',
            },
            {
                question: 'Зачем сервисной точке координаты?',
                answer: 'Координаты позволяют показывать сервис на карте. Их можно определить по адресу или уточнить вручную, переместив метку на карте.',
            },
            {
                question: 'Показывает ли MotorDesk статистику по сервисам?',
                answer: 'Да. В кабинете можно видеть количество выполненных ТО по сервисной точке, а на главной странице — структуру расходов по сервисным точкам за выбранный период.',
            },
            {
                question: 'Можно ли указать график работы и логотип сервиса?',
                answer: 'Да. В карточке можно заполнить режим работы по дням недели и добавить логотип: через URL, favicon сайта или загрузку собственного файла.',
            },
        ],
        cta: {
            title: 'Сохраните проверенные сервисы так, чтобы к ним было легко вернуться и по контакту, и по истории',
            text: 'Сервисные точки дополняют историю ТО: вы видите не только что делали с машиной, но и где именно это происходило, сколько визитов было и какие места сильнее влияют на расходы.',
            primaryAction: {
                label: 'Открыть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
            secondaryAction: {
                label: 'Учёт ТО автомобиля',
                url: APP_ROUTES.MAINTENANCE.INDEX,
            },
        },
        howTo: {
            name: 'Как вести сервисные точки автомобиля в MotorDesk',
            steps: [
                'Добавьте сервисную точку и укажите название, сайт, телефоны и заметки.',
                'Заполните адрес или найдите его на карте, чтобы сохранить координаты.',
                'Привязывайте сервисную точку к выполненным ТО и анализируйте расходы по местам обслуживания.',
            ],
        },
    },
    plan: {
        key: 'plan',
        path: APP_ROUTES.PLAN.INDEX,
        navLabel: 'План ТО',
        applicationCategory: 'UtilitiesApplication',
        image: {
            src: FEATURE_PLAN_COMMON,
            alt: 'План ТО автомобиля в MotorDesk',
        },
        hero: {
            eyebrow: 'План технического обслуживания автомобиля',
            lead: 'MotorDesk помогает занести предстоящее обслуживание на конкретную дату или пробег, оценочно достраивает второй ориентир и показывает будущие работы рядом с сервисной историей. План и выполненные ТО можно выгрузить в XLSX или PDF для архива, анализа или передачи другому человеку.',
            chips: [
                'План ТО по дате',
                'План ТО по пробегу',
                'Оценка второго ориентира',
                'Будущие события',
                'Выгрузка плана в XLSX и PDF',
            ],
            bullets: [
                'Можно создавать будущие работы так, как вам удобнее: по дате или по километражу.',
                'Сервис показывает ориентировочную дату к пробегу или ориентировочный пробег к дате.',
                'Прошедшие и предстоящие события выгружаются в XLSX-таблицу или PDF-документ с настраиваемыми фильтрами.',
            ],
            primaryAction: {
                label: 'Открыть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
            secondaryAction: {
                label: 'Учёт ТО автомобиля',
                url: APP_ROUTES.MAINTENANCE.INDEX,
            },
            image: {
                src: EDITORIAL_MAINTENANCE_PLAN,
                alt: 'Планирование будущих работ и напоминаний по автомобилю',
                caption: 'Когда будущие работы видны заранее, обслуживание перестаёт быть неожиданностью.',
            },
        },
        intro: {
            title: 'План ТО помогает не только помнить о работах, но и сохранять полную картину обслуживания',
            text: 'Большая часть проблем с обслуживанием появляется не потому, что владелец не знает регламент, а потому что нужное событие теряется между пробегом, календарём и обычной занятостью. MotorDesk собирает будущие работы рядом с историей ТО, а при необходимости переносит выбранные данные в XLSX или PDF.',
        },
        sections: [
            {
                id: 'plan-input',
                eyebrow: 'Как это работает',
                title: 'Будущую работу можно задать по дате или по пробегу',
                lead: 'Вы выбираете тот ориентир, который вам действительно понятен в жизни: конкретную дату в календаре или будущий пробег автомобиля.',
                paragraphs: [
                    'Одни работы удобнее привязывать к сезону, отпуску или конкретному месяцу. Другие логичнее задавать по километражу. Поэтому не нужно придумывать сразу обе точки, если вы знаете только одну.',
                ],
                steps: [
                    'Выберите, будет ли событие задано по дате или по пробегу.',
                    'Укажите название работы и при необходимости добавьте комментарий.',
                    'Сохраните событие и увидите его в общем списке будущих работ.',
                ],
                image: {
                    src: FEATURE_PLAN_FORM,
                    alt: 'Форма добавления события плана ТО в MotorDesk',
                    caption: 'Для будущей работы достаточно одного понятного ориентира, чтобы не усложнять ввод.',
                },
            },
            {
                id: 'forecast',
                eyebrow: 'Что даёт оценка',
                title: 'Система помогает понять, когда событие станет актуальным по второй точке',
                paragraphs: [
                    'Если вы задали работу по пробегу, MotorDesk оценочно показывает будущую дату. Если по дате — ориентировочный пробег, на котором автомобиль к ней подойдёт.',
                    'За счёт этого проще понять, насколько близко событие, когда заложить расходы в бюджет и когда лучше планировать визит в сервис.',
                ],
                bullets: [
                    'Ориентир по времени для работ, привязанных к километражу.',
                    'Ориентир по пробегу для работ, привязанных к календарю.',
                    'Более спокойное планирование бюджета и графика.',
                ],
                image: {
                    src: FEATURE_PLAN_FUTURE,
                    alt: 'Будущие события плана ТО с ориентировочными датами и пробегом',
                    caption: 'План ТО показывает не только список работ, но и когда примерно они станут актуальны.',
                },
            },
            {
                id: 'history-context',
                eyebrow: 'Почему это полезно',
                title: 'Будущие работы читаются гораздо понятнее рядом с уже выполненным обслуживанием',
                paragraphs: [
                    'Когда рядом есть история прошлых сервисных событий, проще видеть интервалы между работами, не дублировать лишнее и лучше понимать реальное состояние машины.',
                ],
                image: {
                    src: FEATURE_PLAN_EXIST_EVENTS,
                    alt: 'История выполненных работ рядом с планом ТО в MotorDesk',
                    caption: 'Прошлые обслуживания помогают будущему плану быть осмысленным и точнее связанным с реальной эксплуатацией автомобиля.',
                },
                actions: [
                    {
                        label: 'Учёт ТО автомобиля',
                        url: APP_ROUTES.MAINTENANCE.INDEX,
                    },
                    {
                        label: 'Сервисные точки',
                        url: APP_ROUTES.SERVICE_PROVIDERS.INDEX,
                    },
                    {
                        label: 'Учёт пробега автомобиля',
                        url: APP_ROUTES.MILEAGE.INDEX,
                    },
                ],
            },
            {
                id: 'file-export',
                eyebrow: 'Экспорт данных',
                title: 'План ТО и историю обслуживания можно выгрузить в XLSX или PDF',
                lead: 'Экспорт собирает прошедшие сервисы и предстоящие события активного автомобиля в компактный файл с выбранным форматом.',
                paragraphs: [
                    'В файле дата и пробег приведены к единым столбцам, поэтому прошедшие и будущие события удобно просматривать вместе и передавать. XLSX подходит для сортировки и собственного анализа, а PDF — для чтения, печати или отправки мастеру без редактирования.',
                    'Перед выгрузкой можно выбрать только историю, только будущий план или оба раздела сразу. Для прошедших событий доступен период, а для будущих — состояние события и фильтр по цветам. Детали, комментарии и финансовые суммы также можно включать или исключать.',
                ],
                bullets: [
                    'XLSX для таблицы и PDF для аккуратного просмотра.',
                    'Прошедшие сервисы и предстоящие события в одном файле.',
                    'Фильтр по периоду, актуальности будущих событий и назначенным цветам.',
                    'Отдельные настройки для комментариев, состава деталей и финансовых сумм.',
                ],
                image: {
                    src: FEATURE_PLAN_FILE_EXPORT,
                    alt: 'Пример выгрузки плана ТО автомобиля с прошедшими и предстоящими событиями',
                    caption: 'В готовом файле прошедшие сервисы и будущие работы собраны с датами, пробегом, цветами и комментариями, а суммы можно включить при необходимости.',
                },
                cards: [
                    {
                        title: 'Для личного архива',
                        text: 'Сохраните понятную копию истории и будущего плана вне личного кабинета.',
                    },
                    {
                        title: 'Для сервиса или нового владельца',
                        text: 'Передайте компактный файл с работами, пробегами, датами и комментариями.',
                    },
                    {
                        title: 'Для анализа в Excel',
                        text: 'Фильтруйте строки, сравнивайте стоимость работ и составляйте собственные отчёты.',
                    },
                    {
                        title: 'Для чтения в PDF',
                        text: 'Сохраните план в компактном виде, чтобы отправить его мастеру или распечатать.',
                    },
                ],
                note: 'Выгрузка не изменяет данные в MotorDesk: она формирует отдельный XLSX- или PDF-файл по выбранным настройкам.',
            },
            {
                id: 'practical-benefit',
                eyebrow: 'Практический результат',
                title: 'План ТО помогает заранее распределить бюджет, время и визиты в сервис',
                paragraphs: [
                    'Когда будущие работы видны заранее, легче распределять сервисные расходы по месяцам, заранее искать удобное окно в графике и не доводить обслуживание до срочного режима.',
                ],
                cards: [
                    {
                        title: 'Бюджет заранее',
                        text: 'Проще не собирать несколько сервисных трат в один неожиданный месяц.',
                    },
                    {
                        title: 'Меньше авралов',
                        text: 'Можно записаться в сервис тогда, когда это удобно вам, а не когда уже нельзя тянуть.',
                    },
                    {
                        title: 'Больше ясности',
                        text: 'Будущие работы перестают жить в голове, заметках и разрозненных напоминаниях.',
                    },
                    {
                        title: 'Данные под рукой',
                        text: 'Настраиваемая выгрузка в XLSX или PDF помогает сохранить или передать план вместе с сервисной историей.',
                    },
                ],
            },
        ],
        faq: [
            {
                question: 'Как работает план ТО в MotorDesk?',
                answer: 'Вы создаёте будущее событие либо по дате, либо по пробегу. После этого MotorDesk оценочно показывает второй ориентир на основе истории автомобиля.',
            },
            {
                question: 'Можно ли задать только дату или только пробег?',
                answer: 'Да. Достаточно одного ориентира, а вторую точку сервис подскажет оценочно.',
            },
            {
                question: 'Откуда берётся оценочная дата или пробег?',
                answer: 'Расчёт строится на текущем состоянии автомобиля и накопленной истории пробега.',
            },
            {
                question: 'Помогает ли план ТО готовить бюджет на обслуживание?',
                answer: 'Да. Когда будущие работы видны заранее, легче распределять сервисные траты и не сталкиваться с ними внезапно.',
            },
            {
                question: 'Можно ли выгрузить план ТО и историю обслуживания в файл?',
                answer: 'Да. Можно сформировать XLSX- или PDF-файл с прошедшими сервисами, предстоящими событиями или обоими разделами сразу. Данные размещаются в компактном виде с едиными столбцами даты и пробега.',
            },
            {
                question: 'Какие настройки доступны при выгрузке плана ТО?',
                answer: 'Можно выбрать формат XLSX или PDF, типы событий, период прошедших сервисов, состояние и цвета будущих событий, а также включить или исключить комментарии и детали.',
            },
        ],
        cta: {
            title: 'Соберите план ТО заранее и сохраните его в удобном формате',
            text: 'Держите будущие работы рядом с историей обслуживания, регулярно обновляйте пробег и выгружайте нужные данные в XLSX или PDF.',
            primaryAction: {
                label: 'Открыть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
            secondaryAction: {
                label: 'Учёт ТО автомобиля',
                url: APP_ROUTES.MAINTENANCE.INDEX,
            },
        },
        howTo: {
            name: 'Как вести и выгружать план ТО автомобиля в MotorDesk',
            steps: [
                'Добавьте будущую работу по дате или пробегу и при необходимости назначьте ей цвет и комментарий.',
                'Следите за расчётным вторым ориентиром и сравнивайте будущие события с уже выполненным обслуживанием.',
                'Откройте настройки экспорта, выберите формат XLSX или PDF, нужные типы событий и фильтры, затем скачайте план ТО.',
            ],
        },
    },
    fuel: {
        key: 'fuel',
        path: APP_ROUTES.FUEL.INDEX,
        navLabel: 'Заправки',
        applicationCategory: 'UtilitiesApplication',
        image: {
            src: FEATURE_FUEL_INDEX,
            alt: 'Учёт заправок автомобиля в MotorDesk',
        },
        hero: {
            eyebrow: 'Учёт заправок автомобиля',
            lead: 'MotorDesk помогает сохранять заправки без лишней рутины: литры, стоимость, цену за литр, дату и связь с пробегом. Так топливо перестаёт быть набором чеков и становится частью понятной истории по машине.',
            chips: [
                'Литры и стоимость',
                'Цена за литр',
                'Связь с пробегом',
                'История топлива',
            ],
            bullets: [
                'Калькулятор сразу считает фактический расход топлива на 100 км.',
                'Удобно для регулярных записей по ходу обычной эксплуатации.',
                'Помогает видеть не только стоимость топлива, но и связь заправок с использованием автомобиля.',
                'Даёт более понятную картину расходов по машине.',
            ],
            primaryAction: {
                label: 'Открыть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
            secondaryAction: {
                label: 'Рассчитать расход топлива',
                url: APP_ROUTES.FUEL.INDEX + '#fuel-calculator',
            },
            image: {
                src: EDITORIAL_FUEL_MILEAGE,
                alt: 'Заправка автомобиля и быстрая запись топлива в смартфоне',
                caption: 'Когда заправки сохраняются сразу, по ним проще видеть и расходы, и поведение автомобиля.',
            },
        },
        intro: {
            title: 'Заправки полезно вести не ради архива чеков, а ради ясной картины по топливу',
            text: 'Топливо часто становится одной из самых заметных статей расходов по машине, но без системных записей по нему трудно понять общую картину. MotorDesk помогает сделать такие данные наглядными и полезными.',
        },
        sections: [
            {
                id: 'fuel-recording',
                eyebrow: 'Что фиксируется',
                title: 'В каждой заправке сохраняются именно те данные, которые важны в жизни',
                paragraphs: [
                    'Для реального понимания топлива мало одной общей суммы. Важны и литры, и цена за литр, и дата, и пробег, на котором произошла заправка.',
                ],
                image: {
                    src: FEATURE_FUEL_FORM,
                    alt: 'Форма добавления заправки в MotorDesk',
                    caption: 'Короткий и понятный ввод помогает записывать заправки сразу, пока все данные перед глазами.',
                },
                cards: [
                    {
                        title: 'Литры',
                        text: 'Показывают фактический объём топлива, а не только след в бюджете.',
                    },
                    {
                        title: 'Стоимость',
                        text: 'Помогает видеть, сколько реально уходит на топливо по машине.',
                    },
                    {
                        title: 'Пробег',
                        text: 'Даёт нужный контекст для понимания расхода и общей эксплуатации автомобиля.',
                    },
                ],
            },
            {
                id: 'fuel-analytics',
                eyebrow: 'Что это даёт',
                title: 'История заправок помогает быстрее замечать изменения в расходах на топливо',
                paragraphs: [
                    'Когда заправки собраны в одном месте, проще видеть рост расходов на топливо, сравнивать периоды и замечать, когда машина или ваш маршрут начали вести себя по-другому.',
                ],
                image: {
                    src: DASHBOARD_FUEL_DYNAMICS,
                    alt: 'Динамика топлива в MotorDesk',
                    caption: 'История заправок становится особенно полезной, когда её можно быстро сравнивать по периодам.',
                },
                actions: [
                    {
                        label: 'Калькулятор расхода на поездку',
                        url: APP_ROUTES.TRIP_CALCULATOR.INDEX,
                    },
                    {
                        label: 'Денежные расходы на авто',
                        url: APP_ROUTES.MONEY.INDEX,
                    },
                ],
            },
            {
                id: 'fuel-summary',
                eyebrow: 'В связке с другими данными',
                title: 'Заправки читаются понятнее рядом с пробегом и остальными расходами на машину',
                paragraphs: [
                    'Топливо редко интересно само по себе. Намного полезнее видеть его рядом с пробегом, обслуживанием и остальными расходами, чтобы понимать общую стоимость владения автомобилем.',
                ],
                image: {
                    src: DASHBOARD_FUEL_SUMMARY,
                    alt: 'Сводка по топливу в MotorDesk',
                    caption: 'Топливная картина помогает лучше понимать общие расходы на автомобиль.',
                },
                actions: [
                    {
                        label: 'Калькулятор поездки',
                        url: APP_ROUTES.TRIP_CALCULATOR.INDEX,
                    },
                    {
                        label: 'Учёт пробега автомобиля',
                        url: APP_ROUTES.MILEAGE.INDEX,
                    },
                ],
            },
        ],
        faq: [
            {
                question: 'Что можно фиксировать в заправках автомобиля?',
                answer: 'В MotorDesk можно сохранять дату заправки, литры, стоимость, цену за литр и связь с пробегом автомобиля.',
            },
            {
                question: 'Как рассчитать расход топлива на 100 км?',
                answer: 'Укажите пройденное расстояние и количество израсходованных литров. Калькулятор разделит топливо на километраж и покажет расход на 100 км, общую стоимость и цену 100 км.',
            },
            {
                question: 'Зачем связывать заправки с пробегом?',
                answer: 'Так топливо становится полезным для анализа расходов и понимания общей картины эксплуатации автомобиля.',
            },
            {
                question: 'Помогают ли заправки видеть расходы по машине точнее?',
                answer: 'Да. Когда топливо учитывается системно, становится легче понимать, какая часть бюджета уходит именно на него.',
            },
        ],
        cta: {
            title: 'Сделайте топливо понятной частью общей картины по машине',
            text: 'Если хотите видеть не только литры, но и итоговую цену маршрута, дополните учёт заправок калькулятором стоимости поездки и историей пробега.',
            primaryAction: {
                label: 'Открыть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
            secondaryAction: {
                label: 'Калькулятор поездки',
                url: APP_ROUTES.TRIP_CALCULATOR.INDEX,
            },
        },
    },
    tripCalculator: {
        key: 'tripCalculator',
        path: APP_ROUTES.TRIP_CALCULATOR.INDEX,
        navLabel: 'Калькулятор поездки',
        applicationCategory: 'UtilitiesApplication',
        image: {
            src: DASHBOARD_TRIP_CALCULATOR,
            alt: 'Калькулятор расхода на поездку в MotorDesk',
        },
        hero: {
            eyebrow: 'Калькулятор расхода на поездку',
            lead: 'Выберите города, получите расстояние по дорогам и сразу рассчитайте топливо и стоимость поездки. Ручной ввод километража тоже доступен, а в личном кабинете расчёт можно уточнить по истории автомобиля.',
            chips: [
                'Выбор городов с подсказками',
                'Расстояние по дорогам',
                'Топливо и цена километра',
                'Средние данные MotorDesk',
                'Поездка туда и обратно',
            ],
            bullets: [
                'Расстояние и время в пути рассчитываются по реальному автомобильному маршруту.',
                'Можно ввести километраж вручную, выбрать класс автомобиля и тип топлива.',
                'Средняя цена литра подставляется автоматически, при необходимости её можно изменить.',
                'В кабинете расчёт можно уточнить по истории своей машины.',
            ],
            primaryAction: {
                label: 'Открыть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
            secondaryAction: {
                label: 'Заправки автомобиля',
                url: APP_ROUTES.FUEL.INDEX,
            },
            image: {
                src: DASHBOARD_TRIP_CALCULATOR,
                alt: 'Калькулятор стоимости поездки в MotorDesk',
                caption: 'Калькулятор показывает не только расход топлива на поездку, но и полную стоимость маршрута по данным вашего автомобиля.',
            },
        },
        intro: {
            title: 'Обычный калькулятор расхода топлива показывает литры, а водителю чаще нужна цена поездки',
            text: 'Укажите маршрут или известный километраж, чтобы узнать, сколько топлива понадобится, во сколько обойдётся дорога и как изменится итог для поездки туда и обратно. В личном кабинете расчёт можно уточнить по истории своего автомобиля.',
        },
        sections: [
            {
                id: 'trip-calculator-logic',
                eyebrow: 'Что считает калькулятор',
                title: 'Быстрый расчёт показывает топливо и стоимость маршрута',
                paragraphs: [
                    'Выберите класс автомобиля и топливо, затем уточните средний расход. Расстояние можно ввести вручную или получить по маршруту между городами. Переключатель обратной дороги сразу пересчитает весь итог.',
                    'Калькулятор покажет количество топлива, стоимость 100 километров, цену одного километра и итоговую стоимость маршрута. Если вы ведёте автомобиль в MotorDesk, расчёт можно уточнять по его истории.',
                ],
                image: {
                    src: DASHBOARD_TRIP_CALCULATOR,
                    alt: 'Интерфейс калькулятора расхода на поездку в MotorDesk',
                    caption: 'Расчёт учитывает выбранный маршрут, расход автомобиля и актуальную для вас цену топлива.',
                },
                cards: [
                    {
                        title: 'Топливо',
                        text: 'Показывает стоимость топлива и необходимое количество литров на выбранную дистанцию.',
                    },
                    {
                        title: 'Цена километра',
                        text: 'Помогает быстро понять, во сколько обходится каждый километр маршрута по топливу.',
                    },
                    {
                        title: 'Туда и обратно',
                        text: 'Одним переключателем удваивает дистанцию и сразу пересчитывает итоговую сумму.',
                    },
                    {
                        title: 'Данные MotorDesk',
                        text: 'Подставляет среднюю цену литра и позволяет изменить её вручную.',
                    },
                ],
            },
            {
                id: 'trip-calculator-benefit',
                eyebrow: 'Почему это полезно',
                title: 'Получите больше, чем количество литров на дорогу',
                paragraphs: [
                    'Количество литров не показывает, как поездка повлияет на бюджет. Для планирования полезно сразу видеть стоимость 100 километров, одного километра и всего маршрута.',
                    'Укажите класс автомобиля, тип топлива и расход — MotorDesk рассчитает основные показатели в одном месте.',
                    'Если вы ведёте историю заправок в кабинете, расчёт сможет опираться на данные вашей машины и станет точнее.',
                ],
                image: {
                    src: DASHBOARD_FUEL_SUMMARY,
                    alt: 'Топливная сводка как база для калькулятора поездки в MotorDesk',
                    caption: 'История заправок связывает литры, стоимость топлива и пробег автомобиля.',
                },
                actions: [
                    {
                        label: 'Заправки автомобиля',
                        url: APP_ROUTES.FUEL.INDEX,
                    },
                    {
                        label: 'Учёт пробега автомобиля',
                        url: APP_ROUTES.MILEAGE.INDEX,
                    },
                ],
            },
            {
                id: 'trip-calculator-context',
                eyebrow: 'Как это связано с MotorDesk',
                title: 'Калькулятор поездки особенно силён там, где уже ведутся регулярные записи по машине',
                paragraphs: [
                    'Чем полнее заполнены пробег, заправки, обслуживание и другие расходы, тем точнее можно оценивать поездки и эксплуатацию автомобиля.',
                    'Связанные данные помогают спокойнее планировать маршруты, бюджет по машине и повседневные поездки.',
                ],
                image: {
                    src: DASHBOARD_EXPENSES_SUMMARY,
                    alt: 'Структура расходов автомобиля как база для калькулятора поездки в MotorDesk',
                    caption: 'Полная стоимость поездки становится понятнее, когда топливо, сервис и остальные траты уже собраны в одной системе.',
                },
                actions: [
                    {
                        label: 'Расходы на автомобиль',
                        url: APP_ROUTES.MONEY.INDEX,
                    },
                    {
                        label: 'Все возможности MotorDesk',
                        url: APP_ROUTES.FEATURES.INDEX,
                    },
                ],
                note: 'Если нужен только расчёт литров, калькулятор тоже решает эту задачу. Но его главная ценность в том, что он сразу переводит маршрут в понятную стоимость владения автомобилем.',
            },
        ],
        faq: [
            {
                question: 'Можно ли использовать MotorDesk как калькулятор расхода топлива на поездку?',
                answer: 'Да. В калькуляторе можно быстро оценить топливную часть поездки по дистанции, классу автомобиля и типу топлива. В личном кабинете расчёт можно уточнять по своей истории автомобиля.',
            },
            {
                question: 'Можно ли рассчитать поездку для бензинового автомобиля?',
                answer: 'Да. Выберите бензин, укажите средний расход автомобиля и при необходимости скорректируйте цену литра.',
            },
            {
                question: 'Чем этот расчёт отличается от обычного онлайн-калькулятора?',
                answer: 'Обычный калькулятор чаще всего считает только литры по введённой норме расхода. MotorDesk также показывает стоимость маршрута, а в кабинете может опираться на фактическую историю автомобиля.',
            },
            {
                question: 'Нужно ли отдельно вводить расход на каждую поездку?',
                answer: 'Нет. Калькулятор использует уже накопленные данные по пробегу, заправкам и расходам, поэтому их не нужно вводить заново для каждой поездки.',
            },
        ],
        cta: {
            title: 'Попробуйте перейти от быстрой оценки к точному расчёту по своей машине',
            text: 'Калькулятор помогает быстро сориентироваться. Когда в MotorDesk накоплены топливо, пробег и расходы, расчёт поездки становится ближе к вашей реальной эксплуатации.',
            primaryAction: {
                label: 'Открыть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
            secondaryAction: {
                label: 'Заправки автомобиля',
                url: APP_ROUTES.FUEL.INDEX,
            },
        },
        howTo: {
            name: 'Как рассчитать стоимость поездки в MotorDesk',
            steps: [
                'Выберите класс автомобиля и топливо, при необходимости скорректируйте цену литра и средний расход.',
                'Введите километраж вручную или переключитесь на маршрут и выберите города отправления и назначения.',
                'При необходимости включите дорогу туда и обратно — итог пересчитается автоматически.',
                'Для более точного расчёта ведите пробег, заправки и расходы в личном кабинете MotorDesk.',
            ],
        },
    },
    routeDistance: {
        key: 'routeDistance',
        path: APP_ROUTES.ROUTE_DISTANCE.INDEX,
        navLabel: 'Расстояние между городами',
        applicationCategory: 'UtilitiesApplication',
        image: {
            src: DASHBOARD_TRIP_CALCULATOR,
            alt: 'Калькулятор расстояния между городами на автомобиле',
        },
        hero: {
            eyebrow: 'Расстояние между городами на автомобиле',
            lead: 'Рассчитайте расстояние между городами по автомобильным дорогам, примерное время в пути и общую протяжённость маршрута туда и обратно.',
            chips: [
                'Маршрут по дорогам',
                'Время в пути',
                'Туда и обратно',
                'Выбор городов с подсказками',
            ],
            bullets: [
                'Автоподбор помогает выбрать нужный город и регион без неоднозначности.',
                'Расстояние считается по автомобильному маршруту, а не по прямой линии.',
                'Полученный километраж можно использовать в калькуляторе стоимости поездки.',
            ],
            primaryAction: {
                label: 'Рассчитать расстояние',
                url: APP_ROUTES.ROUTE_DISTANCE.INDEX + '#distance-calculator',
            },
            secondaryAction: {
                label: 'Стоимость поездки',
                url: APP_ROUTES.TRIP_CALCULATOR.INDEX,
            },
            image: {
                src: DASHBOARD_TRIP_CALCULATOR,
                alt: 'Маршрут и расчёт расстояния между двумя городами',
                caption: 'Маршрутный расчёт связывает расстояние, время в дороге и будущую стоимость поездки.',
            },
        },
        intro: {
            title: 'Введите «откуда» и «куда» — расстояние рассчитается автоматически',
            text: 'Калькулятор помогает быстро узнать расстояние между городами на машине и оценить продолжительность поездки. Выбранные точки сохраняются локально в браузере, поэтому повторный расчёт занимает меньше времени.',
        },
        sections: [
            {
                id: 'how-route-distance-works',
                eyebrow: 'Как считается маршрут',
                title: 'Не расстояние по прямой, а реальный путь по автомобильным дорогам',
                paragraphs: [
                    'После выбора городов MotorDesk строит автомобильный маршрут и показывает его длину вместе с примерным временем в пути.',
                    'Расчёт учитывает дорожную сеть между населёнными пунктами, поэтому результат точнее расстояния по прямой.',
                ],
                cards: [
                    {
                        title: 'Точный выбор места',
                        text: 'В подсказке видны город, регион и полное название, поэтому проще выбрать нужный населённый пункт.'
                    },
                    {
                        title: 'Длина маршрута',
                        text: 'Показываем километры по дорогам в одну сторону или сразу для поездки туда и обратно.'
                    },
                    {
                        title: 'Время в пути',
                        text: 'Расчётная продолжительность помогает планировать поездку, но не учитывает текущие пробки и остановки.'
                    },
                ],
            },
            {
                id: 'from-distance-to-trip-cost',
                eyebrow: 'Следующий шаг',
                title: 'Переведите расстояние в литры и стоимость поездки',
                paragraphs: [
                    'Одного километража часто недостаточно: для планирования бюджета полезно знать расход топлива, стоимость 100 км и итоговую сумму маршрута.',
                    'В калькуляторе поездки используется тот же выбор городов, а расстояние переносится в расчёт автоматически. Остаётся уточнить расход автомобиля и цену литра.',
                ],
                actions: [
                    {label: 'Рассчитать стоимость поездки', url: APP_ROUTES.TRIP_CALCULATOR.INDEX},
                    {label: 'Калькулятор расхода топлива', url: APP_ROUTES.FUEL.INDEX + '#fuel-calculator'},
                ],
            },
            {
                id: 'route-accuracy',
                eyebrow: 'Точность результата',
                title: 'Что важно учитывать при планировании дороги',
                paragraphs: [
                    'Время является ориентировочным: на него могут повлиять пробки, ремонт дорог, погода, остановки и выбранный темп движения. Перед выездом проверьте дорожную обстановку в навигаторе.',
                    'Маршрут строится между выбранными населёнными пунктами. Точный адрес внутри города и промежуточные остановки могут изменить фактический километраж.',
                ],
            },
        ],
        faq: [
            {
                question: 'Как рассчитать расстояние между городами на машине?',
                answer: 'Начните вводить названия в полях «Откуда» и «Куда» и выберите оба города из подсказок. Сервис автоматически построит маршрут и покажет расстояние по дорогам и примерное время в пути.',
            },
            {
                question: 'Можно ли посчитать маршрут туда и обратно?',
                answer: 'Да. Включите переключатель «Туда и обратно», и калькулятор покажет суммарные километры и продолжительность для обеих сторон поездки.',
            },
            {
                question: 'Учитывает ли расчёт пробки?',
                answer: 'Нет. Время в пути является маршрутной оценкой без текущих пробок, остановок, погоды и временных ограничений движения.',
            },
            {
                question: 'Можно ли использовать расстояние для расчёта стоимости поездки?',
                answer: 'Да. Перейдите в калькулятор поездки: выбранные города и километраж будут доступны для расчёта топлива и итоговой стоимости маршрута.',
            },
            {
                question: 'Откуда берутся данные маршрута?',
                answer: 'Маршрут рассчитывается по дорожным данным OpenStreetMap с помощью OpenRouteService.',
            },
        ],
        cta: {
            title: 'Расстояние известно — теперь рассчитайте стоимость поездки',
            text: 'Перейдите в калькулятор поездки, уточните расход и цену топлива или сохраните автомобиль в MotorDesk для персональных расчётов.',
            primaryAction: {label: 'Калькулятор поездки', url: APP_ROUTES.TRIP_CALCULATOR.INDEX},
            secondaryAction: {label: 'Открыть демо', url: env.URL_LK_DEMO, external: true},
        },
        howTo: {
            name: 'Как рассчитать расстояние между городами',
            steps: [
                'Введите названия города отправления и назначения и выберите варианты из подсказок.',
                'При необходимости включите расчёт дороги туда и обратно.',
                'Получите расстояние и примерное время в пути автоматически — результат обновится после выбора городов или переключения обратной дороги.',
            ],
        },
    },
    mileage: {
        key: 'mileage',
        path: APP_ROUTES.MILEAGE.INDEX,
        navLabel: 'Пробег',
        applicationCategory: 'UtilitiesApplication',
        image: {
            src: FEATURE_MILEAGE_INDEX,
            alt: 'Учёт пробега автомобиля в MotorDesk',
        },
        hero: {
            eyebrow: 'Учёт пробега автомобиля',
            lead: 'MotorDesk помогает просто и регулярно фиксировать пробег автомобиля, чтобы он перестал быть случайной цифрой и стал опорой для топлива, обслуживания, будущих работ и общей картины эксплуатации машины.',
            chips: [
                'Фиксация пробега',
                'История километража',
                'Основа для аналитики',
                'База для плана ТО',
            ],
            bullets: [
                'Полезен даже как самый первый шаг в системном учёте автомобиля.',
                'Даёт основу для более точного понимания топлива и обслуживания.',
                'Помогает смотреть на машину по данным, а не по ощущениям.',
            ],
            primaryAction: {
                label: 'Открыть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
            secondaryAction: {
                label: 'План ТО автомобиля',
                url: APP_ROUTES.PLAN.INDEX,
            },
            image: {
                src: FEATURE_MILEAGE_INDEX,
                alt: 'История пробега автомобиля в MotorDesk',
                caption: 'Регулярный учёт пробега помогает точнее понимать темп эксплуатации автомобиля.',
            },
        },
        intro: {
            title: 'Пробег кажется простой цифрой, пока от него не начинает зависеть всё остальное',
            text: 'Интервалы ТО, понимание топлива, оценка будущих работ и общий темп использования машины часто завязаны именно на километраж. Поэтому даже простой учёт пробега даёт большую практическую пользу.',
        },
        sections: [
            {
                id: 'mileage-role',
                eyebrow: 'Зачем это нужно',
                title: 'История пробега становится опорой для обслуживания, топлива и планирования',
                paragraphs: [
                    'Если пробег вносится регулярно, остальные разделы по машине становятся понятнее. Заправки получают нужный контекст, обслуживание читается по интервалам, а будущие работы можно оценивать точнее.',
                ],
                image: {
                    src: DASHBOARD_CURRENT_MILEAGE,
                    alt: 'Текущий пробег автомобиля в MotorDesk',
                    caption: 'Пробег даёт простой, но очень важный ориентир для многих решений по машине.',
                },
                cards: [
                    {
                        title: 'План ТО',
                        text: 'Помогает понимать, когда будущая работа станет актуальной по километражу.',
                        action: {
                            label: 'Открыть план ТО',
                            url: APP_ROUTES.PLAN.INDEX,
                        },
                    },
                    {
                        title: 'Заправки',
                        text: 'Без пробега топливо остаётся просто набором сумм без нужного контекста.',
                        action: {
                            label: 'Открыть заправки',
                            url: APP_ROUTES.FUEL.INDEX,
                        },
                    },
                    {
                        title: 'История обслуживания',
                        text: 'По пробегу проще понимать интервалы между сервисными работами.',
                        action: {
                            label: 'Открыть учёт ТО',
                            url: APP_ROUTES.MAINTENANCE.INDEX,
                        },
                    },
                ],
            },
            {
                id: 'mileage-everyday',
                eyebrow: 'Как это вести',
                title: 'Чем проще сохранить пробег в нужный момент, тем полезнее становится вся история',
                paragraphs: [
                    'Лучше всего учёт пробега работает тогда, когда на запись уходит минимум усилий. Поэтому в MotorDesk этот раздел остаётся максимально прикладным и подходит для коротких повседневных действий.',
                ],
                image: {
                    src: FEATURE_MILEAGE_FORM,
                    alt: 'Форма добавления пробега в MotorDesk',
                    caption: 'Простой ввод помогает записывать пробег регулярно, а не вспоминать о нём задним числом.',
                },
                actions: [
                    {
                        label: 'Telegram-бот для автовладельца',
                        url: APP_ROUTES.BOT.INDEX,
                    },
                    {
                        label: 'Открыть демо',
                        url: env.URL_LK_DEMO,
                        external: true,
                    },
                ],
            },
            {
                id: 'mileage-forecast',
                eyebrow: 'Что это меняет',
                title: 'История пробега помогает заранее понимать, как быстро приближаются будущие работы',
                paragraphs: [
                    'Когда пробег ведётся системно, обслуживание легче планировать не по приблизительным ощущениям, а по реальной динамике использования автомобиля.',
                ],
                image: {
                    src: DASHBOARD_MILEAGE_BY_MONTHS,
                    alt: 'Динамика пробега по месяцам в MotorDesk',
                    caption: 'Динамика пробега помогает лучше оценивать темп эксплуатации и будущие сервисные события.',
                },
                actions: [
                    {
                        label: 'План ТО автомобиля',
                        url: APP_ROUTES.PLAN.INDEX,
                    },
                ],
            },
        ],
        faq: [
            {
                question: 'Зачем отдельно вести пробег автомобиля?',
                answer: 'Пробег помогает точнее понимать топливо, обслуживание, будущие работы и общий темп эксплуатации машины.',
            },
            {
                question: 'Помогает ли история пробега планировать ТО?',
                answer: 'Да. Именно по накопленной истории пробега легче оценивать, когда будущие работы приблизятся к нужному километражу.',
            },
            {
                question: 'Можно ли вносить пробег быстро и без долгого ввода?',
                answer: 'Да. Для этого в MotorDesk есть короткий прикладной сценарий и возможность использовать Telegram-бот для быстрых действий.',
            },
        ],
        cta: {
            title: 'Начните с пробега, если хотите постепенно собрать всю картину по машине',
            text: 'Даже один этот раздел уже даёт полезную основу для топлива, обслуживания и будущего плана по автомобилю.',
            primaryAction: {
                label: 'Открыть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
            secondaryAction: {
                label: 'План ТО автомобиля',
                url: APP_ROUTES.PLAN.INDEX,
            },
        },
    },
    moneyExpenses: {
        key: 'moneyExpenses',
        path: APP_ROUTES.MONEY.INDEX,
        navLabel: 'Денежные расходы',
        applicationCategory: 'UtilitiesApplication',
        image: {
            src: FEATURE_MONEY_INDEX,
            alt: 'Денежные расходы на автомобиль в MotorDesk',
        },
        hero: {
            eyebrow: 'Денежные расходы на автомобиль',
            lead: 'MotorDesk помогает учитывать отдельные денежные траты по машине: парковку, мойку, налоги, штрафы, страховку и другие платежи. Так мелкие и нерегулярные расходы перестают ускользать из общей картины.',
            chips: [
                'Парковка и мойка',
                'Налоги и штрафы',
                'Страховка',
                'Прочие траты',
            ],
            bullets: [
                'Помогает видеть реальные траты по машине шире, чем только топливо и сервис.',
                'Делает заметными регулярные и нерегулярные платежи, которые обычно теряются.',
                'Удобен для контроля стоимости владения автомобилем по периодам.',
            ],
            primaryAction: {
                label: 'Открыть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
            secondaryAction: {
                label: 'Заправки автомобиля',
                url: APP_ROUTES.FUEL.INDEX,
            },
            image: {
                src: EDITORIAL_OWNERSHIP_ANALYTICS,
                alt: 'Аналитика расходов на автомобиль и общей стоимости владения',
                caption: 'Когда все отдельные траты собраны вместе, легче увидеть реальную стоимость владения автомобилем.',
            },
        },
        intro: {
            title: 'Не все заметные траты по машине связаны с топливом или ремонтом',
            text: 'Парковка, мойка, страховка, налоги, штрафы и другие платежи часто кажутся небольшими по отдельности, но именно они формируют большой слой расходов, который легко недооценить без системного учёта.',
        },
        sections: [
            {
                id: 'money-structure',
                eyebrow: 'Что сюда входит',
                title: 'Здесь удобно собирать те траты, которые обычно теряются между делом',
                paragraphs: [
                    'Такие расходы редко записывают так же аккуратно, как заправки или обслуживание, поэтому они часто остаются незаметными.',
                ],
                image: {
                    src: FEATURE_MONEY_FORM,
                    alt: 'Форма добавления денежного расхода в MotorDesk',
                    caption: 'Короткий ввод помогает не откладывать запись расходов на потом.',
                },
                actions: [
                    {
                        label: 'Заправки автомобиля',
                        url: APP_ROUTES.FUEL.INDEX,
                    },
                    {
                        label: 'Учёт ТО автомобиля',
                        url: APP_ROUTES.MAINTENANCE.INDEX,
                    },
                ],
            },
            {
                id: 'money-benefit',
                eyebrow: 'Что это даёт',
                title: 'Когда такие траты видны отдельно, проще понять настоящую стоимость владения',
                paragraphs: [
                    'Даже если каждая сумма кажется небольшой, вместе они могут сильно влиять на бюджет автомобиля. Системный учёт помогает видеть повторяющиеся траты и заранее готовиться к более крупным платежам.',
                ],
                cards: [
                    {
                        title: 'Парковка и мойка',
                        text: 'Расходы, которые происходят часто и поэтому особенно легко теряются.',
                    },
                    {
                        title: 'Налоги и штрафы',
                        text: 'Платежи, по которым важно помнить и сумму, и время.',
                    },
                    {
                        title: 'Страховка и прочее',
                        text: 'Траты, которые заметно влияют на общую стоимость владения автомобилем.',
                    },
                ],
            },
            {
                id: 'money-system',
                eyebrow: 'Вместе с другими разделами',
                title: 'Финансовая картина по машине становится заметно яснее рядом с топливом и обслуживанием',
                paragraphs: [
                    'Отдельные денежные расходы особенно полезны тогда, когда вы видите их вместе с заправками и сервисной историей. Так проще понимать не одну категорию трат, а всю картину владения автомобилем.',
                ],
                image: {
                    src: DASHBOARD_EXPENSES_SUMMARY,
                    alt: 'Сводка по расходам на автомобиль в MotorDesk',
                    caption: 'Когда все траты по машине собраны вместе, заметно легче понимать их влияние на бюджет.',
                },
                actions: [
                    {
                        label: 'Заправки автомобиля',
                        url: APP_ROUTES.FUEL.INDEX,
                    },
                    {
                        label: 'Калькулятор поездки',
                        url: APP_ROUTES.TRIP_CALCULATOR.INDEX,
                    },
                    {
                        label: 'Сервисные точки',
                        url: APP_ROUTES.SERVICE_PROVIDERS.INDEX,
                    },
                    {
                        label: 'Все возможности MotorDesk',
                        url: APP_ROUTES.FEATURES.INDEX,
                    },
                ],
            },
        ],
        faq: [
            {
                question: 'Какие расходы входят в этот раздел?',
                answer: 'Парковка, мойка, налоги, штрафы, страховка, дорожные сборы, аксессуары и другие расходы по машине.',
            },
            {
                question: 'Почему заправки идут отдельным разделом?',
                answer: 'Потому что у топлива своя логика учёта: литры, цена за литр, пробег и отдельная история расходов.',
            },
            {
                question: 'Можно ли видеть эти траты вместе с остальными расходами по машине?',
                answer: 'Да. В кабинете денежные расходы дополняют топливо, обслуживание и другие события по автомобилю.',
            },
        ],
        cta: {
            title: 'Соберите даже мелкие траты так, чтобы они больше не ускользали из внимания',
            text: 'Это помогает спокойнее планировать бюджет по машине и лучше понимать, сколько автомобиль действительно стоит в повседневной жизни.',
            primaryAction: {
                label: 'Открыть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
            secondaryAction: {
                label: 'Заправки автомобиля',
                url: APP_ROUTES.FUEL.INDEX,
            },
        },
    },
    notes: {
        key: 'notes',
        path: APP_ROUTES.NOTES.INDEX,
        navLabel: 'Заметки',
        applicationCategory: 'UtilitiesApplication',
        image: {
            src: FEATURE_NOTES_HERO,
            alt: 'Автовладелец сохраняет заметку рядом с автомобилем',
        },
        hero: {
            eyebrow: 'Записная книжка автовладельца',
            lead: 'Сохраните то, что легко потерять между поездками и делами: странный звук, номер детали, вопрос мастеру, идею для доработки или обещание проверить машину позже.',
            chips: [
                'Симптомы и наблюдения',
                'Номера деталей',
                'Вопросы мастеру',
                'Привязка к автомобилю',
                'XLSX и PDF',
                'Личный кабинет и Telegram',
            ],
            bullets: [
                'Заметку можно оставить общей или привязать к конкретному автомобилю из гаража.',
                'Короткую мысль можно записать сразу через Telegram-бота — она сохранится на текущий автомобиль.',
                'В кабинете удобно фильтровать записи, выделять их цветом и выгружать в XLSX или PDF.',
            ],
            primaryAction: {
                label: 'Открыть кабинет',
                url: env.URL_LK,
                external: true,
            },
            secondaryAction: {
                label: 'Открыть Telegram-бота',
                url: env.BOT_URL,
                external: true,
            },
            image: {
                src: FEATURE_NOTES_HERO,
                alt: 'Водитель записывает наблюдение по автомобилю в телефон',
                caption: 'Самая полезная заметка — та, которую удалось сохранить сразу, пока подробности ещё свежи.',
            },
        },
        intro: {
            title: 'Чтобы важная мелочь по машине не исчезла из памяти',
            text: 'Не каждое наблюдение уже является ремонтом, расходом или пунктом плана ТО. Иногда сначала нужно просто сохранить мысль и вернуться к ней позже. Для этого и нужны заметки.',
        },
        sections: [
            {
                id: 'what-to-note',
                eyebrow: 'Что записывать',
                title: 'Место для вопросов и наблюдений, которые пока не относятся к другим разделам',
                paragraphs: [
                    'Запишите, при каких условиях появился звук, какой артикул советовали на форуме, что спросить при следующем визите в сервис или что проверить перед дальней поездкой.',
                    'Запись можно оставить общей или связать с конкретной машиной. Когда задача станет конкретной, её можно перенести в план ТО, обслуживание или расходы. До этого момента заметка сохранит контекст.',
                ],
                cards: [
                    {title: 'Наблюдение', text: '«На холодную пару секунд слышен свист справа» — с условиями, которые помогут объяснить симптом мастеру.'},
                    {title: 'Номер детали', text: 'Артикул, размер шин или подходящий расходник не потеряется среди вкладок и переписок.'},
                    {title: 'Вопрос на сервис', text: 'Список того, что стоит уточнить при следующем визите, остаётся под рукой.'},
                ],
            },
            {
                id: 'two-channels',
                eyebrow: 'Как сохранить',
                title: 'Запишите мысль там, где она появилась',
                paragraphs: [
                    'В дороге или рядом с машиной удобнее отправить текст Telegram-боту. Такая запись сохраняется на текущий автомобиль, чтобы потом не вспоминать, к какой машине относилось наблюдение.',
                    'Оба способа ведут в одну записную книжку, поэтому записи не приходится искать по разным местам.',
                ],
                image: {
                    src: FEATURE_NOTES_CHANNELS,
                    alt: 'Единые заметки в личном кабинете и на телефоне',
                    caption: 'Telegram помогает быстро сохранить мысль, а кабинет — спокойно разобрать накопившиеся записи.',
                },
                actions: [
                    {label: 'Telegram-бот MotorDesk', url: APP_ROUTES.BOT.INDEX},
                    {label: 'План ТО автомобиля', url: APP_ROUTES.PLAN.INDEX},
                ],
            },
            {
                id: 'filters-and-export',
                eyebrow: 'Порядок в заметках',
                title: 'Когда записей становится много, помогают фильтры, цвета и выгрузка',
                paragraphs: [
                    'Заметки можно искать по тексту, фильтровать по автомобилю и датам создания или изменения. Цветовые метки помогают визуально отделять срочные вопросы, идеи для будущего ТО или общие наблюдения.',
                    'Если нужно разобрать записи отдельно, отправить список мастеру или сохранить локальную копию, заметки можно выгрузить в XLSX для таблицы или PDF для чтения.',
                ],
                cards: [
                    {
                        title: 'Фильтр по автомобилю',
                        text: 'Покажите только записи по нужной машине или оставьте общий список вместе с заметками без привязки.'
                    },
                    {
                        title: 'Цветовые метки',
                        text: 'Выделяйте важные записи цветом, чтобы быстрее находить нужный контекст в длинном списке.'
                    },
                    {
                        title: 'Экспорт XLSX и PDF',
                        text: 'Скачайте заметки с выбранными фильтрами в удобном формате: таблица для обработки или PDF для чтения.'
                    },
                ],
            },
            {
                id: 'note-or-plan',
                eyebrow: 'Заметка или план',
                title: 'Заметка сохраняет мысль, план ТО назначает конкретное действие',
                paragraphs: [
                    'Если вы пока только заметили симптом или хотите позже изучить вопрос, используйте заметку. Если уже понятно, что и когда нужно сделать, создайте пункт плана ТО по дате или пробегу.',
                    'Так список будущих работ остаётся точным, а полезные наблюдения всё равно не теряются.',
                ],
                actions: [
                    {label: 'План ТО', url: APP_ROUTES.PLAN.INDEX},
                    {label: 'Учёт обслуживания', url: APP_ROUTES.MAINTENANCE.INDEX},
                ],
            },
        ],
        faq: [
            {
                question: 'Что можно записывать в заметки автовладельца?',
                answer: 'Любой короткий текст: симптомы и наблюдения по машине, номера деталей, вопросы мастеру, идеи, напоминания и подготовку к поездке.',
            },
            {
                question: 'Можно ли добавить заметку через Telegram?',
                answer: 'Да. Выберите в меню бота команду «Записать заметку» и отправьте текст следующим сообщением. Запись появится в личном кабинете и будет привязана к текущему автомобилю.',
            },
            {
                question: 'Заметка привязана к конкретному автомобилю?',
                answer: 'Может быть привязана, но это необязательно. В личном кабинете можно выбрать автомобиль для заметки или оставить её общей. В списке доступны фильтры по автомобилям и заметкам без привязки.',
            },
            {
                question: 'Можно ли выгрузить заметки из MotorDesk?',
                answer: 'Да. В личном кабинете заметки можно выгрузить по выбранным фильтрам в XLSX или PDF: например, только по одному автомобилю, периоду или цветовой метке.',
            },
            {
                question: 'Чем заметка отличается от плана ТО?',
                answer: 'Заметка нужна, чтобы не потерять мысль или наблюдение. План ТО нужен для конкретной будущей работы с ориентиром по дате или пробегу.',
            },
        ],
        cta: {
            title: 'Запишите то, что не должно потеряться до следующего визита к машине или мастеру',
            text: 'Короткая запись сейчас часто экономит время на поиске деталей и восстановлении контекста позже.',
            primaryAction: {
                label: 'Открыть кабинет',
                url: env.URL_LK,
                external: true,
            },
            secondaryAction: {
                label: 'Telegram-бот',
                url: APP_ROUTES.BOT.INDEX,
            },
        },
        howTo: {
            name: 'Как сохранить заметку через Telegram-бота MotorDesk',
            steps: [
                'Выберите в MotorDesk текущий автомобиль, если заметка относится к конкретной машине.',
                'Откройте меню Telegram-бота и выберите «Записать заметку».',
                'Отправьте следующим сообщением текст, который хотите сохранить.',
                'Откройте раздел «Заметки» в личном кабинете, чтобы перечитать или отредактировать запись.',
            ],
        },
    },
    bot: {
        key: 'bot',
        path: APP_ROUTES.BOT.INDEX,
        navLabel: 'Telegram-бот',
        applicationCategory: 'UtilitiesApplication',
        image: {
            src: BOT_IMAGE,
            alt: 'Telegram-бот MotorDesk для автовладельца',
        },
        hero: {
            eyebrow: 'Telegram-бот для автовладельца',
            lead: 'Telegram-бот MotorDesk помогает быстрее выполнять короткие повседневные действия по машине: записывать пробег, рассчитывать поездку, добавлять заправки и открывать нужные данные без лишних переходов.',
            chips: [
                'Быстрый ввод пробега',
                'Расчёт поездки',
                'Добавление заправок',
                'Доступ к данным авто',
                'Связка с кабинетом',
            ],
            bullets: [
                'Подходит для коротких действий без открытия браузера.',
                'Полезен там, где важно не откладывать запись до удобного момента.',
                'Работает как дополнение к личному кабинету, а не вместо него.',
            ],
            primaryAction: {
                label: 'Открыть бота',
                url: env.BOT_URL,
                external: true,
            },
            secondaryAction: {
                label: 'Открыть кабинет',
                url: env.URL_LK,
                external: true,
            },
            image: {
                src: BOT_IMAGE,
                alt: 'Telegram-бот MotorDesk',
                caption: 'Бот особенно полезен там, где нужно быстро сохранить событие по машине прямо в момент его появления.',
            },
        },
        intro: {
            title: 'Бот помогает не терять повседневные записи по машине',
            text: 'Когда вы на заправке, в дороге или просто не хотите открывать браузер ради одного короткого действия, Telegram-бот заметно упрощает путь до нужной записи или данных по автомобилю.',
        },
        sections: [
            {
                id: 'bot-role',
                eyebrow: 'В чём польза',
                title: 'Если до записи слишком длинный путь, её легко отложить и забыть',
                paragraphs: [
                    'Бот помогает сократить этот путь. Чем проще зафиксировать событие, тем больше шансов, что история по машине будет полной и полезной.',
                ],
                actions: [
                    {
                        label: 'Учёт пробега автомобиля',
                        url: APP_ROUTES.MILEAGE.INDEX,
                    },
                    {
                        label: 'Заправки автомобиля',
                        url: APP_ROUTES.FUEL.INDEX,
                    },
                ],
            },
            {
                id: 'bot-capabilities',
                eyebrow: 'Что можно делать',
                title: 'Бот особенно удобен для коротких и частых действий',
                cards: [
                    {
                        title: 'Пробег',
                        text: 'Сохраняйте текущий километраж по активному автомобилю без лишних шагов.',
                    },
                    {
                        title: 'Расчёт поездки',
                        text: 'Отправьте дистанцию и отметьте обратную дорогу, чтобы быстро получить примерную стоимость маршрута.',
                    },
                    {
                        title: 'Заправки',
                        text: 'Добавляйте топливо тогда, когда чек и данные находятся прямо перед вами.',
                    },
                    {
                        title: 'Быстрый доступ',
                        text: 'Открывайте нужную информацию по машине в привычном канале общения.',
                    },
                ],
            },
            {
                id: 'bot-system',
                eyebrow: 'Как это связано с кабинетом',
                title: 'Записи из бота сразу становятся частью общей истории по автомобилю',
                paragraphs: [
                    'Пробег, записанный через Telegram, остаётся полезен для обслуживания и планирования. Заправка сразу дополняет общую картину топлива и расходов. За счёт этого быстрые действия в боте не живут отдельно от остальных данных по машине.',
                ],
                image: {
                    src: DASHBOARD_MILEAGE_BY_YEARS,
                    alt: 'История автомобиля в MotorDesk после быстрых записей',
                    caption: 'Быстрый ввод особенно ценен тогда, когда он сразу попадает в общую историю владения автомобилем.',
                },
                actions: [
                    {
                        label: 'Все возможности MotorDesk',
                        url: APP_ROUTES.FEATURES.INDEX,
                    },
                    {
                        label: 'Открыть демо',
                        url: env.URL_LK_DEMO,
                        external: true,
                    },
                ],
            },
        ],
        faq: [
            {
                question: 'Для чего нужен Telegram-бот MotorDesk?',
                answer: 'Он нужен для быстрых действий по машине: записи пробега, добавления заправок и быстрого доступа к данным без браузера.',
            },
            {
                question: 'Заменяет ли бот личный кабинет?',
                answer: 'Нет. Личный кабинет остаётся основным местом работы с данными, а бот помогает быстрее выполнять короткие повседневные действия.',
            },
            {
                question: 'С какими разделами бот связан сильнее всего?',
                answer: 'В первую очередь с пробегом и заправками, потому что именно эти события чаще всего хочется сохранить сразу.',
            },
        ],
        cta: {
            title: 'Подключите быстрый способ работы с машиной на каждый день',
            text: 'Если не хочется откладывать короткие записи до возвращения к компьютеру, Telegram-бот хорошо дополняет кабинет и делает учёт заметно проще.',
            primaryAction: {
                label: 'Открыть бота',
                url: env.BOT_URL,
                external: true,
            },
            secondaryAction: {
                label: 'Заправки автомобиля',
                url: APP_ROUTES.FUEL.INDEX,
            },
        },
    },
    demo: {
        key: 'demo',
        path: APP_ROUTES.DEMO.INDEX,
        navLabel: 'Демо',
        applicationCategory: 'UtilitiesApplication',
        image: {
            src: EDITORIAL_HERO_CONTROL,
            alt: 'Demo-режим MotorDesk',
        },
        hero: {
            eyebrow: 'Demo-режим MotorDesk',
            lead: 'Демо показывает, как MotorDesk выглядит в реальной работе: пробег, заправки, обслуживание, сервисные точки, будущие работы и расходы по машине.',
            chips: [
                'Read-only доступ',
                'Насыщенные данные',
                'Знакомство с кабинетом',
                'История автомобиля',
            ],
            bullets: [
                'Показывает основные разделы на примере заполненного автомобиля.',
                'Помогает быстро понять, удобен ли вам такой формат учёта.',
                'Позволяет заранее разобраться в структуре кабинета.',
            ],
            primaryAction: {
                label: 'Открыть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
            secondaryAction: {
                label: 'Создать кабинет',
                url: env.URL_LK_REGISTER,
                external: true,
            },
            image: {
                src: EDITORIAL_HERO_CONTROL,
                alt: 'Демо-кабинет MotorDesk',
                caption: 'Демо позволяет быстро увидеть, как все важные события по машине собираются в одну картину.',
            },
        },
        intro: {
            title: 'Если хочется сначала посмотреть сервис вживую, демо снимает лишние сомнения',
            text: 'Демо показывает кабинет с понятными данными и помогает оценить, насколько такой формат учёта подходит для вашей машины.',
        },
        sections: [
            {
                id: 'demo-what-inside',
                eyebrow: 'Что вы увидите',
                title: 'Внутри демо можно посмотреть ключевые разделы по машине',
                paragraphs: [
                    'В демо видны записи по пробегу, заправкам, обслуживанию, сервисным точкам, расходам и будущим работам. Этого достаточно, чтобы понять общий подход к учёту и представить, как может выглядеть ваша собственная история автомобиля.',
                ],
                image: {
                    src: DASHBOARD_CURRENT_MILEAGE,
                    alt: 'Текущие данные автомобиля в demo MotorDesk',
                    caption: 'Даже короткое знакомство с демо помогает лучше почувствовать, подходит ли вам такой формат работы с автомобилем.',
                },
                actions: [
                    {
                        label: 'Открыть демо',
                        url: env.URL_LK_DEMO,
                        external: true,
                    },
                    {
                        label: 'Сервисные точки',
                        url: APP_ROUTES.SERVICE_PROVIDERS.INDEX,
                    },
                ],
            },
            {
                id: 'demo-why',
                eyebrow: 'Что дальше',
                title: 'После знакомства с демо проще решить, хотите ли вы вести машину именно так',
                paragraphs: [
                    'Если формат оказывается удобным, можно переходить в кабинет уже с пониманием того, как будут выглядеть ваши записи, расходы и будущие работы.',
                ],
                image: {
                    src: DASHBOARD_EXPENSES_SUMMARY,
                    alt: 'Сводка по данным автомобиля в demo MotorDesk',
                    caption: 'Демо помогает перейти от любопытства к более осознанному решению попробовать сервис на своей машине.',
                },
                actions: [
                    {
                        label: 'Создать кабинет',
                        url: env.URL_LK_REGISTER,
                        external: true,
                    },
                    {
                        label: 'Все возможности MotorDesk',
                        url: APP_ROUTES.FEATURES.INDEX,
                    },
                ],
            },
        ],
        faq: [
            {
                question: 'Как устроен demo-режим MotorDesk?',
                answer: 'Это заполненный обезличенный кабинет в режиме просмотра. В нём можно открыть основные разделы и увидеть связи между данными автомобиля.',
            },
            {
                question: 'Что показывает demo-режим?',
                answer: 'Он показывает основные данные по автомобилю: пробег, заправки, обслуживание, будущие работы и расходы.',
            },
            {
                question: 'Можно ли работать в демо как в полноценном кабинете?',
                answer: 'Нет. Demo предназначен для знакомства и работает в режиме просмотра.',
            },
        ],
        cta: {
            title: 'Посмотрите сервис вживую и решите, подходит ли он вашей машине',
            text: 'Если формат вам подходит, создайте кабинет и начните вести историю своего автомобиля.',
            primaryAction: {
                label: 'Открыть демо',
                url: env.URL_LK_DEMO,
                external: true,
            },
            secondaryAction: {
                label: 'Создать кабинет',
                url: env.URL_LK_REGISTER,
                external: true,
            },
        },
    },
};
